import { render, staticRenderFns } from "./tcDivideManagerCommon2.vue?vue&type=template&id=05fe8405&"
import script from "./tcDivideManagerCommon2.vue?vue&type=script&lang=js&"
export * from "./tcDivideManagerCommon2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports